import { useEffect, useState } from 'react';

/**
 * The EVII assistant orb — the same animated-WebP brand mark the driver app
 * uses (apps/web EvieOrb), copied into the shop so the public assistant wears
 * the identical face. Loops natively over a transparent background; honours
 * `prefers-reduced-motion: reduce` by swapping in the static poster frame.
 *
 * Assets live in apps/shop/public/ alongside the app copies:
 *   - /evie-orb.webp         animated, loops natively
 *   - /evie-orb-poster.webp  static first frame (reduced-motion + poster)
 */
export function EvieOrb({
  size = 24,
  className,
  title = 'EVII™',
}: {
  size?: number;
  className?: string;
  title?: string;
}) {
  const [reducedMotion, setReducedMotion] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReducedMotion(mql.matches);
    const handler = (e: MediaQueryListEvent) => setReducedMotion(e.matches);
    mql.addEventListener('change', handler);
    return () => mql.removeEventListener('change', handler);
  }, []);

  return (
    <img
      src={reducedMotion ? '/evie-orb-poster.webp' : '/evie-orb.webp'}
      alt={title}
      width={size}
      height={size}
      draggable={false}
      className={className}
      style={{ display: 'block', width: size, height: size, flexShrink: 0 }}
    />
  );
}
